import { ForwardedRef, forwardRef, ReactNode } from 'react'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardHeader from '@mui/material/CardHeader'
import Divider from '@mui/material/Divider'
import { useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'

const headerSX = {
  '& .MuiCardHeader-action': { mr: 0 },
}

type MainCardProps = {
  border?: boolean
  boxShadow?: string
  children?: ReactNode
  content?: boolean
  contentClass?: string
  contentSX?: object
  darkTitle?: boolean
  secondary?: string
  shadow?: string
  sx?: object
  title?: string
  elevation?: number
}
export const MainCard = forwardRef(
  (
    {
      border = true,
      children,
      content = true,
      contentClass = '',
      contentSX = {},
      darkTitle,
      secondary,
      title,
    }: MainCardProps,
    ref: ForwardedRef<HTMLDivElement>
  ) => {
    const theme = useTheme()
    return (
      <Card
        ref={ref}
        sx={{
          border: border ? '1px solid' : 'none',
          borderColor: theme.palette.primary.main,
          '&:hover': {
            boxShadow: '0 2px 14px 0 rgb(33 150 243 / 10%)',
          },
        }}
      >
        {!darkTitle && title && <CardHeader action={secondary} sx={headerSX} title={title} />}
        {darkTitle && title && (
          <CardHeader
            action={secondary}
            sx={headerSX}
            title={<Typography variant={'h3'}>{title}</Typography>}
          />
        )}

        {title && <Divider />}

        {content && (
          <CardContent className={contentClass} sx={contentSX}>
            {children}
          </CardContent>
        )}
        {!content && children}
      </Card>
    )
  }
)
